import { React, useState, useEffect } from "react";

const PopUpRouletteResults = ({ resultsData, catMid, marketType }) => {
    const resultData = resultsData;

    useEffect(() => {
        console.log("Market Type:", marketType);
        console.log("Results Data:", resultsData);
    }, [resultsData, marketType]);

    const dataObj = resultsData;

    const formatMarketStartTime = (dateString) => {
        if (!dateString) return "";

        const date = new Date(dateString);

        if (isNaN(date.getTime())) return "";

        return date.toLocaleString("en-US", {
            month: "numeric",
            day: "numeric",
            year: "numeric",
            hour: "numeric",
            minute: "2-digit",
            second: "2-digit",
            hour12: true
        });
    };

    return (
        <div>
            <div id="ResultsData">
                <div class="left-content site_family">
                    <div id="roulette" style={{ display: marketType == 10 ? "" : "none" }}>
                        <div className="left-content">
                            <div className="card">
                                <div className="card-header">
                                    Market Start Time = {formatMarketStartTime(dataObj.evt_od)}
                                </div>
                                <div className="card-body">
                                    <div
                                        style={{
                                            textAlign: "center"
                                        }}
                                    >
                                        <h2 style={{ marginBottom: "10px" }}>
                                            Winner
                                        </h2>
                                        <div
                                            style={{
                                                fontSize: "30px",
                                                fontWeight: "700",
                                                color: "#cf8d2e"
                                            }}
                                        >
                                            {resultData.result}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PopUpRouletteResults;

